module.exports = __webpack_public_path__ + "img/support-my-book.566c4f2.svg";